import { UserRole } from '../../../../../../store/api/manager-api';

export const adminRecord: Record<UserRole, string> = {
  admin_head: 'Главный администратор',
  admin_branch: 'Администратор филиала',
};
